import Joi from '@hapi/joi'

export const DailyBlockSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group Name").messages({
        "any.invalid": `Group Name cannot have invalid characters`,
        "any.required": `Group Name is required`
    }),
    estateID: Joi.number().invalid(0).required().label("Operation Entity Name").messages({
        "any.invalid": `Operation Entity Name cannot have invalid characters`,
        "any.required": `Operation Entity Name is required`
    }),
    divisionID: Joi.number().invalid(0).required().label("Division Name").messages({
        "any.invalid": `Division Name cannot have invalid characters`,
        "any.required": `Division Name is required`
    }),
    date: Joi.string().invalid("").label("Date"),
    fieldID: Joi.number().required().label("Field Name").messages({
        "any.invalid": `Field Name cannot have invalid characters`,
        "any.required": `Field Name is required`
    }),
    blockID: Joi.number().required().label("Block Name").messages({
        "any.invalid": `Block Name cannot have invalid characters`,
        "any.required": `Block Name is required`
    })
}